// 동기화 전역 일시정지 플래그
// 매뉴얼(사용 설명서) 데모 API 핸들러가 전역 httpRequest에 설치되는 동안,
// 백그라운드 동기화의 실제 업로드/다운로드가 데모 응답으로 처리되어
// "서버에 저장되지 않았는데 성공 처리"되는 데이터 유실을 막는다.
// 순환 참조를 피하기 위해 의존성 없는 독립 모듈로 둔다.

let suspendCount = 0

// 동기화 일시정지 (중첩 호출 가능)
export function suspendSync(): void {
  suspendCount++
}

// 동기화 재개 (suspend와 짝을 맞춰 호출)
export function resumeSync(): void {
  if (suspendCount > 0) suspendCount--
}

// 동기화가 일시정지 상태인지 여부
export function isSyncSuspended(): boolean {
  return suspendCount > 0
}
